export const SEARCH_TITLE = "activation.home.search.title";
export const SEARCH_WEBSITE_PLACEHOLDER = "activation.home.search.website.input.placeholder";
export const SEARCH_KEYWORD_PLACEHOLDER = "activation.home.search.keyword.input.placeholder";
export const WEBSITE_TAB_TITLE = "common.website";
export const KEYWORD_TAB_TITLE = "common.keyword";
export const NO_RESULTS = "activation.home.projects.list.empty.title";
